import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSensuComponent } from './simple-icons-sensu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSensuComponent ],
    exports:      [ SimpleIconsSensuComponent ],
    bootstrap:    []
})
export class SimpleIconsSensuModule {}
